import { ParticipantTypes } from "./ParticipantTypes";
import Pesel from '../../utils/pesel';

const validEmailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const validPasswordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-/(/)=/+`~;:[/\]/?/{/}"'<>_\\\\|]).{8,}$/;

export const signInFormValidation = values => {
  const errors = {};
  const requiredFields = [
    'email',
    'password',
  ];
  
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Pole jest wymagane';
    }
  });

  if (values.email && !validEmailRegex.test(values.email)) {
    errors.email = 'Adres email jest nieprawidłowy';
  }
  if (values.password && values.password.length < 8) {
    errors.password = 'Hasło musi zawierać co najmniej 8 znaków';
  }
  
  return errors;
};

export const accountActivationFormValidation = values => {
  const errors = {};
  
  if (!values.newPassword || !validPasswordRegex.test(values.newPassword)) {
    errors.newPassword = 'Hasło musi zawierać co najmniej 8 znaków, w tym jedną cyfrę, wielką literę oraz znak specjalny';
  }

  return errors;
};

export const passwordRecoveryFormValidation = values => {
  const errors = {};
  
  if (!values.email || !validEmailRegex.test(values.email)) {
    errors.email = 'Adres email jest nieprawidłowy';
  }

  return errors;
};

export const registrationFormValidation = (values, consent1Required, consent2Required) => {
  const errors = {};
  errors[`${values.participantType}Data`] = { address: {} };

  const requiredFields = [
    'email',
    'firstName',
    'lastName',
    'password',
  ];

  if (consent1Required) requiredFields.push('consent1');
  if (consent2Required) requiredFields.push('consent2');
  
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Pole jest wymagane';
    }
  });
  
  if (values.email && !validEmailRegex.test(values.email)) {
    errors.email = 'Adres email jest nieprawidłowy';
  }

  if (!values.password || !validPasswordRegex.test(values.password)) {
    errors.password = 'Hasło musi zawierać co najmniej 8 znaków, w tym jedną cyfrę, wielką literę oraz znak specjalny';
  }

  if (values.participantType === ParticipantTypes.naturalPerson) {
    if (!values.naturalPersonData || (values.naturalPersonData.pesel && !new Pesel(values.naturalPersonData.pesel).isValid())) {
      errors.naturalPersonData.pesel = 'Numer pesel nie jest prawidłowy';
    }
  }

  if (values.participantType === ParticipantTypes.legalEntity) {
    if (!values.legalEntityData || !values.legalEntityData.name) {
      errors.legalEntityData.name = 'Pole jest wymagane';
    }

    if (!values.legalEntityData || !values.legalEntityData.taxId) {
      errors.legalEntityData.taxId = 'Numer NIP jest wymagany';
    }

    if (!values.legalEntityData || !values.legalEntityData.regon) {
      errors.legalEntityData.regon = 'Numer REGON jest wymagany';
    }
  }

  const addressFields = [
    'street',
    'streetNumber',
    'zipCode',
    'city',
  ];

  if (values[`${values.participantType}Data`] && values[`${values.participantType}Data`].address && addressFields.some(field => values[`${values.participantType}Data`].address[field] != null)) {
    addressFields.forEach(field => {
      if (!values[`${values.participantType}Data`].address[field]) {
        errors[`${values.participantType}Data`].address[field] = 'Pole jest wymagane';
      }
    });
  }

  return errors;
};

export const userProfileValidation = values => {
  const errors = {};
  errors[`${values.participantType}Data`] = { address: {} };

  const requiredFields = [
    'firstName',
    'lastName',
  ];
  
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Pole jest wymagane';
    }
  });
  
  if (values.participantType === ParticipantTypes.naturalPerson) {
    if (!values.naturalPersonData || (values.naturalPersonData.pesel && !new Pesel(values.naturalPersonData.pesel).isValid())) {
      errors.naturalPersonData.pesel = 'Numer pesel nie jest prawidłowy';
    }
  }

  if (values.participantType === ParticipantTypes.legalEntity) {
    if (!values.legalEntityData || !values.legalEntityData.name) {
      errors.legalEntityData.name = 'Pole jest wymagane';
    }

    if (!values.legalEntityData || !values.legalEntityData.taxId) {
      errors.legalEntityData.taxId = 'Numer NIP jest wymagany';
    }

    if (!values.legalEntityData || !values.legalEntityData.regon) {
      errors.legalEntityData.regon = 'Numer REGON jest wymagany';
    }
  }

  const addressFields = [
    'street',
    'streetNumber',
    'zipCode',
    'city',
  ];

  if (values[`${values.participantType}Data`] && values[`${values.participantType}Data`].address && addressFields.some(field => values[`${values.participantType}Data`].address[field] != null)) {
    addressFields.forEach(field => {
      if (!values[`${values.participantType}Data`].address[field]) {
        errors[`${values.participantType}Data`].address[field] = 'Pole jest wymagane';
      }
    });
  }
  
  return errors;
};



// WEBPACK FOOTER //
// ./src/models/auth/AuthModelValidation.js